import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'modify_paxselector';
export const route = 'modify_paxselector/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modify_paxselector" */
/* webpackPrefetch: true */
'../components/PaxSelectorPage')));